import { render, staticRenderFns } from "./OverviewTaxDisplay.vue?vue&type=template&id=bb84f9a8&"
import script from "./OverviewTaxDisplay.vue?vue&type=script&lang=js&"
export * from "./OverviewTaxDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports